import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/markdown',
      name: 'Markdown',
      component: () => import('../components/MyMarkdown')
    },
    {
      path: '/',
      name: 'index',
      component: () => import('../../res/Index')
    },
    {
      path: '/atHome',
      name: 'AtHome',
      component: () => import('../../res/AtHome')
    },
    {
      path: '/experience',
      name: 'Experience',
      component: () => import('../../res/Experience')
    },
    {
      path: '/addNurse',
      name: 'AddNurse',
      component: () => import('../../res/AddNurse')
    },
    {
      path: '/mall',
      name: 'Home',
      component: () => import('../views/Home')
    },
    {
      path: '/error',
      name: 'Error',
      component: () => import('../components/Error')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../components/MyLogin')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../views/About')
    },
    {
      path: '/goods',
      name: 'Goods',
      component: () => import('../views/Goods')
    },
    {
      path: '/goods/details',
      name: 'Details',
      component: () => import('../views/Details')
    },
    {
      path: '/shoppingCart',
      name: 'ShopCart',
      component: () => import('../views/ShopCart'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/collect',
      name: 'Collect',
      component: () => import('../views/Collect'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('../views/Order'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/confirmOrder',
      name: 'ConfirmOrder',
      component: () => import('../views/ConfirmOrder'),
      meta: {
        requireAuth: true
      }
    }
  ]
})
/* 由于Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理。
vue-router先报了一个Uncaught(in promise)的错误(因为push没加回调) ，然后再点击路由的时候才会触发NavigationDuplicated的错误(路由出现的错误，全局错误处理打印了出来)。 */
// 禁止全局路由错误处理打印
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js